/**
 * GT Featured Products Component JavaScript
 * 功能：处理热卖产品组件的颜色切换和图片更新
 * 作者：GT Team
 * 创建时间：2024-12-19
 * 最后修改：2024-12-19
 */

// 检查类是否已经存在，避免重复声明
if (typeof window.GTFeaturedProduct === 'undefined') {
  window.GTFeaturedProduct = class {
    constructor(container) {
      this.container = container;
      this.mediaContainer = container.querySelector('.product-media-container');
      this.mainImage = container.querySelector('[data-main-image]');
      this.colorSelectors = container.querySelectorAll('.color-selector');
      
      this.init();
    }

    init() {
      if (!this.colorSelectors.length || !this.mainImage) {
        return;
      }

      this.colorSelectors.forEach(selector => {
        selector.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          this.updateActiveState(selector);
          this.switchMainImage(selector);
        });
      });
    }

    updateActiveState(activeSelector) {
      // 移除其他选择器的active类
      this.colorSelectors.forEach(s => s.classList.remove('active'));
      // 为当前点击的色块添加激活状态
      activeSelector.classList.add('active');
    }

    switchMainImage(selector) {
      const imageUrl = selector.dataset.variantImage;
      
      if (!imageUrl || imageUrl.includes('Liquid error')) {
        return;
      }
      
      if (!this.mainImage) {
        return;
      }
      
      // 构建响应式srcset
      const newSrcset = this.buildSrcset(imageUrl);
      const newSrc = this.buildSrc(imageUrl);
      
      // 更新图片
      this.mainImage.srcset = newSrcset;
      this.mainImage.src = newSrc;
    }

    buildSrcset(imageUrl) {
      // 获取基础URL和版本号
      const baseUrl = imageUrl.split('?')[0];
      const version = imageUrl.match(/\?v=\d+/)?.[0] || '';
      
      // 构建新的 srcset
      const widths = [165, 360, 533, 720, 940];
      return widths
        .map(width => `${baseUrl}${version}&width=${width} ${width}w`)
        .join(',');
    }

    buildSrc(imageUrl) {
      // 获取基础URL和版本号
      const baseUrl = imageUrl.split('?')[0];
      const version = imageUrl.match(/\?v=\d+/)?.[0] || '';
      
      return `${baseUrl}${version}&width=533`;
    }
  };
}

// 初始化所有产品卡片
document.addEventListener('DOMContentLoaded', () => {
  const productCards = document.querySelectorAll('.gt-featured-product-card');
  productCards.forEach(card => new window.GTFeaturedProduct(card));
});

